export default __webpack_public_path__ + "static/media/gallery-3.331957a6.jpg";